import createAction from 'Store/utils/createAction';
import { UPDATE_TRIP_DATE_CRITERIA } from 'Store/constants';

function updateTripDateCriteria(options) {
  return createAction(UPDATE_TRIP_DATE_CRITERIA, options);
}

export { updateTripDateCriteria };
